/* amh-variant-promo.js - extracted from snippets/promo-badge.liquid on 2026-09-14.
   It was inlined once per render of that snippet (12 copies on the CZ product page, 24 on the home
   page), of which all but one did nothing but ship: the IIFE self-guards on window.__amhVp. Loaded
   as a module now, so the browser fetches and runs it exactly once and caches it across pages. */
(function(){
  if(window.__amhVp) return; window.__amhVp=1;
  var css='.artmie-vp-card{position:relative}.artmie-vp-card .amh-vptag{position:absolute;top:6px;right:6px;background:#EF56A9;color:#fff;font-size:10px;font-weight:700;padding:2px 7px;border-radius:100px;box-shadow:0 1px 3px rgba(0,0,0,.28);z-index:6;font-family:Poppins,sans-serif;line-height:1.3;pointer-events:none}'
    +'.amh-cardflag{position:relative;z-index:5;display:inline-flex;align-items:center;gap:5px;margin:8px 0 2px;background:#EF56A9;color:#fff;border:none;border-radius:100px;padding:5px 11px;font-family:Poppins,sans-serif;font-size:11px;font-weight:600;cursor:pointer;line-height:1.2;box-shadow:0 2px 7px rgba(239,86,169,.32)}'
    +'.amh-cardflag:hover{filter:brightness(1.08)}.amh-cardflag svg{width:12px;height:12px;flex-shrink:0}.amh-cardflag__pct{font-weight:700}.amh-cardflag__code{background:rgba(255,255,255,.24);padding:1px 6px;border-radius:100px;letter-spacing:.02em;white-space:nowrap}'
    +'.amh-cardflag--ribbon{position:absolute;margin:0;transform:translateX(-50%);z-index:20;white-space:nowrap;padding:3px 9px;font-size:10px;box-shadow:0 4px 11px rgba(239,86,169,.5)}.amh-cardflag--ribbon svg{width:11px;height:11px}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);
  function tag(c){ if(!c.getAttribute) return; var id=c.getAttribute('data-variant-id'); var p=window.AMHP&&window.AMHP[id]; if(p&&!c.querySelector('.amh-vptag')){ var t=document.createElement('span'); t.className='amh-vptag'; t.textContent=p.badge||'%'; c.appendChild(t); } }
  function scan(r){ if(r&&r.querySelectorAll) r.querySelectorAll('.artmie-vp-card').forEach(tag); }
  // Anchor the ribbon to .product-card (overflow:visible + position:relative) and pin it to the
  // basket button's top-center, so none of the inner overflow:hidden wrappers clip it.
  function positionRibbon(flag, card){
    var btn=card.querySelector('.product-card-actions__button--cart');
    if(!btn) return false;
    var cr=card.getBoundingClientRect(), br=btn.getBoundingClientRect();
    if(!br.width || !br.height) return false;      // button not laid out yet
    var h=flag.offsetHeight||20;
    var gapBelow=6, gapAbove=4;                    // white space to the button; min clearance from the price
    var top=br.top - cr.top - h - gapBelow;        // sit above the button
    var price=card.querySelector('.price-container')||card.querySelector('[class*="price"]');
    if(price){                                     // but NEVER cover the price
      var prBottom=price.getBoundingClientRect().bottom - cr.top;
      if(top < prBottom + gapAbove) top = prBottom + gapAbove;
    }
    flag.style.top=Math.round(top)+'px';
    flag.style.left=Math.round(br.left - cr.left + br.width/2)+'px';
    return true;
  }
  // A badge must never outlive the discount it advertises. Two writers set these metafields:
  //   • Hub promos (services/promos.ts) stamp every entry with its owner promo (`__p`). Every
  //     variant a LIVE Hub promo badges is in window.__AMHPROMOS — the store-level map rebuilt
  //     on each deploy AND each teardown (snippets/amh-promo.liquid). Stamped but absent from
  //     the map = the promo is gone and the metafield was never cleaned up. Hide it.
  //   • google-promo-display.ts writes UNSTAMPED entries for live cuts and reconciles its whole
  //     desired state every day, so it cannot strand one. Those are trusted as-is.
  // Without this the card advertises whatever was last written: the PROFI canvas showed "-25%"
  // for three weeks after its promo was torn down (2026-09-02).
  function mapReady(){ var M=window.__AMHPROMOS; return (M && typeof M==='object') ? M : null; }
  function promoLive(flag){
    var MAP=mapReady(), m=null, pv=flag.getAttribute('data-amh-pv');
    if(pv){ try{ m=JSON.parse(pv); }catch(e){} }
    if(m){
      var stamped=false;
      for(var k in m){
        if(!Object.prototype.hasOwnProperty.call(m,k)) continue;
        if(!m[k] || m[k].__p==null) return true;      // self-reconciling writer — trust it
        stamped=true;
        if(MAP && MAP[k]) return true;                // owner promo still live on this store
      }
      // The map ships at the end of <body>; before load we cannot tell live from stale, so stay
      // hidden. After load, a missing map means the global snippet is not installed on this
      // store — hiding every badge over a bad install would be worse than one stale badge.
      if(stamped) return MAP ? false : document.readyState==='complete';
    }
    if(!MAP) return document.readyState==='complete';
    var vid=flag.getAttribute('data-amh-vid');        // whole-product promo: the map holds every variant
    return !!(vid && MAP[vid]);
  }
  // PERF 2026-09-16: PageSpeed Insights measured 343.9 ms of forced synchronous layout in this
  // file - the largest single source on the product page, and the storefront's INP is 635 ms
  // (SLOW) in CrUX field data. The old loop did read -> write -> read -> write PER BADGE
  // (getComputedStyle, appendChild, three getBoundingClientRect calls, two style writes), so each
  // badge forced its own layout over a ~5,000 node DOM, and the whole loop re-ran on every body
  // mutation. Same visual result, restructured into three passes: attach (writes), measure (all
  // reads together = ONE layout), position (writes), coalesced so a burst of mutations costs
  // one pass.
  var placeTimer=0;
  function placeFlagsNow(){
    var items=[];
    // pass 1 - attach only; no geometry is read here
    document.querySelectorAll('.amh-cardflag[data-amh-product]').forEach(function(flag){
      var card=document.querySelector('.product-card[data-product-id="'+flag.getAttribute('data-amh-product')+'"]');
      if(!card) return;
      if(!promoLive(flag)){ flag.hidden=true; return; }
      if(!flag.__amh || !flag.isConnected){        // (re)attach if new or detached by a re-render
        flag.classList.add('amh-cardflag--ribbon');
        card.appendChild(flag);
        flag.hidden=false;
        flag.__amh=1;
        if(!flag.__amhWired){
          flag.__amhWired=1;
          ['pointerdown','mousedown','pointerup','touchstart','touchend'].forEach(function(ev){ flag.addEventListener(ev, function(e){ e.stopPropagation(); }, true); });
          flag.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); var b=card.querySelector('.product-card-actions__button--cart'); if(b) b.click(); }, true);
        }
      }
      items.push({ flag: flag, card: card });
    });
    if(!items.length) return;
    // pass 2 - every read, back to back, so the browser lays out once for all of them
    var measured=[];
    for(var i=0;i<items.length;i++){
      var flag=items[i].flag, card=items[i].card;
      var btn=card.querySelector('.product-card-actions__button--cart');
      if(!btn) continue;
      var br=btn.getBoundingClientRect();
      if(!br.width || !br.height) continue;        // button not laid out yet
      var cr=card.getBoundingClientRect();
      var price=card.querySelector('.price-container')||card.querySelector('[class*="price"]');
      measured.push({
        flag: flag,
        card: card,
        isStatic: getComputedStyle(card).position==='static',
        h: flag.offsetHeight||20,
        crTop: cr.top, crLeft: cr.left,
        brTop: br.top, brLeft: br.left, brW: br.width,
        prBottom: price ? price.getBoundingClientRect().bottom : null
      });
    }
    // pass 3 - every write, back to back; nothing is read again
    var gapBelow=6, gapAbove=4;                    // white space to the button; min clearance from the price
    for(var j=0;j<measured.length;j++){
      var m=measured[j];
      if(m.isStatic) m.card.style.position='relative';
      var top=m.brTop - m.crTop - m.h - gapBelow;  // sit above the button
      if(m.prBottom!=null){                        // but NEVER cover the price
        var pb=m.prBottom - m.crTop;
        if(top < pb + gapAbove) top = pb + gapAbove;
      }
      m.flag.style.top=Math.round(top)+'px';
      m.flag.style.left=Math.round(m.brLeft - m.crLeft + m.brW/2)+'px';
    }
  }
  function placeFlags(){
    // Coalesce a burst of mutations into one pass. Deliberately NOT requestAnimationFrame: rAF is
    // starved in background/throttled tabs (the fleet lesson from the game badge), and these flags
    // are server-rendered hidden and only revealed by this code - so on a page opened in a
    // background tab the badges would never appear at all. A timer always fires.
    if(placeTimer) return;
    placeTimer=setTimeout(function(){ placeTimer=0; placeFlagsNow(); }, 0);
  }
  new MutationObserver(function(ms){ ms.forEach(function(m){ (m.addedNodes||[]).forEach(function(n){ if(n.nodeType===1){ if(n.classList&&n.classList.contains('artmie-vp-card')) tag(n); scan(n); } }); }); placeFlags(); }).observe(document.body,{childList:true,subtree:true});
  // The ladder existed because each pass was expensive and easy to miss; a coalesced pass is
  // cheap, and 'load' + resize already cover images finishing. Two catch-ups are enough.
  scan(document); placeFlags(); [600,2000].forEach(function(t){ setTimeout(placeFlags,t); });
  addEventListener('resize', placeFlags); addEventListener('load', placeFlags);
})();
